<template>
  <div v-if="!note.busy" class="course-detail-view">

    <!-- content delete modal -->
    <b-modal id="author-delContent-confirm"
             :title="i18n.delContentTitle"
             header-bg-variant="danger"
             ok-variant="danger"
             :ok-title="i18n.delete"
             :cancel-title="i18n.cancel"
             @ok="delContent"
             centered>
      <p>{{ i18n.delContentWarn }}</p>
    </b-modal>

    <!-- course delete modal -->
    <b-modal id="author-delCourse-confirm"
             :title="i18n.delCourseTitle"
             header-bg-variant="danger"
             ok-variant="danger"
             :ok-title="i18n.delete"
             :cancel-title="i18n.cancel"
             @ok="delCourse"
             centered>
      <p v-html="i18n.delCourseWarn"></p>
    </b-modal>

    <!-- course rename modal -->
    <b-modal id="author-renameCourse-confirm"
             :title="i18n.renameCourseTitle"
             header-bg-variant="warning"
             ok-variant="warning"
             :ok-title="i18n.renameCourseOK"
             :cancel-title="i18n.cancel"
             @ok="renameCourse"
             centered>
      <p>
        {{ i18n.renameCourseLabel }}<input
          type="text"
          v-model="renameCourseNewName"
          class="form-control"
          :placeholder="i18n.renameCoursePlaceholder">
      </p>
    </b-modal>

    <!-- course copy modal -->
    <b-modal id="author-copyCourse-confirm"
             :title="i18n.copyCourseTitle"
             header-bg-variant="warning"
             ok-variant="warning"
             :ok-title="i18n.copyCourseOK"
             :cancel-title="i18n.cancel"
             @ok="copyCourse"
             centered>
      <p>
        {{ i18n.copyCourseLabel }}<input
          type="text"
          v-model="copyCourseNewName"
          class="form-control"
          :placeholder="i18n.copyCoursePlaceholder">
      </p>
    </b-modal>

    <!-- content change type modal -->
    <b-modal id="author-changeContentType-confirm"
             :title="i18n.changeContentTypeTitle"
             header-bg-variant="warning"
             ok-variant="warning"
             :ok-title="i18n.changeContentTypeOK"
             :cancel-title="i18n.cancel"
             @ok="changeContentType"
             centered>
      <p>
        {{ i18n.changeContentTypeNew }}
        <b-form-select
            v-model="changetype"
            :options="plugins">
        </b-form-select>
      </p>
    </b-modal>

    <b-toast id="author-toast"
             title="Autor-Tools"
             static
             variant="success"
             auto-hide-delay="1500"
             class="author-toast">
      {{ i18n.saveSuccess }}
    </b-toast>

    <!-- course header -->
    <div class="container-fluid bg-dark">
      <div class="row">
        <div class="col">

          <h1 class="text-center text-light py-5">
            <b>{{ course.name }}</b>
          </h1>

        </div>
      </div>
    </div>

    <!-- content -->
    <div class="container content">
      <div class="row">
        <div class="col">

          <div id="main-content-anchor" style="height: 7rem"></div>

          <component v-if="content()"
                     :key="id+'-'+step"
                     :is="content().name"
                     v-bind="content().input"
                     :onFinish="nextStep(content().nextStep)">
          </component>

          <h2 v-else class="mt-5 text-center text-muted">
            {{ i18n.contentEmpty }}
          </h2>

        </div>
      </div>
    </div>

    <div style="height: 4rem"></div>

    <!-- author view -->
    <div class="ly-bg-author py-4" v-if="isAuthor">

      <div class="container mb-4">
        <div class="row">
          <div class="col">
            <b-button
                variant="outline-secondary"
                size="sm"
                active-class="active"
                :to="{name: 'course-detail-view', params: {id, step}}"
                exact>
              <i class="fas fa-chevron-left"></i> {{ i18n.backToOverview }}
            </b-button>

            <!-- jump to content number -->
            <span class="content-nav float-right" style="font-size: 120%">
                <b-dropdown id="cid-dd"
                            :text="i18n.goToContent"
                            size="sm"
                            variant="secondary"
                            no-flip
                            right>
                  <b-dropdown-item v-for="(c,id) in course.content" :key="id"
                                   :to="{name: 'course-detail-view',
                                   params: {id, step: id+1+''}}">
                    {{ i18n.content }} <b>{{ id + 1 }}</b>
                  </b-dropdown-item>
                </b-dropdown>
              </span>

          </div>
        </div>
      </div>

      <router-view
          :content="content()"
          :onupdate="updateStep"
          :course="course"
          :onnavupdate="updateContent">
      </router-view>

      <div class="container" v-if="isAuthor && $route.name == 'course-detail-view'">

        <!-- edit content -->
        <div class="row mb-2" v-if="content()">
          <div class="col">
            <b-button variant="primary" block append
                      :to="{path: 'edit', params: {type: content.name}}">
              <i class="fas fa-edit"></i> {{ i18n.editContentButton }}
            </b-button>
          </div>

          <div class="col text-dark" v-html="i18n.editContent(step)">
          </div>
        </div>

        <!-- change content type -->
        <div class="row mb-2" v-if="content()">
          <div class="col">
            <b-button variant="warning" block
                      @click="$bvModal.show('author-changeContentType-confirm')">
              <i class="fas fa-edit"></i> {{ i18n.editContentType }}
            </b-button>
          </div>

          <div class="col text-dark" v-html="i18n.editContentTypeText">
          </div>
        </div>

        <!-- new content -->
        <div class="row mb-2">
          <div class="col">

            <b-dropdown id="new-content-dd"
                        variant="primary"
                        class="w-100"
                        dropright>
              <template slot="button-content">
                <i class="fas fa-plus"></i> {{ i18n.addNewContent }}
              </template>

              <b-dropdown-header>{{ i18n.learningModules }}</b-dropdown-header>
              <b-dropdown-item v-for="block in $laya.lb"
                               :key="block.id"
                               :to="'/courses/'+id+'/'+nextId()+'/new/'+block.id">
                {{ block.i18n.de }}
              </b-dropdown-item>

              <b-dropdown-divider></b-dropdown-divider>

              <b-dropdown-header>{{ i18n.learningChecks }}</b-dropdown-header>
              <b-dropdown-item v-for="ass in $laya.la"
                               :key="ass.id"
                               :to="'/courses/'+id+'/'+nextId()+'/new/'+ass.id">
                {{ ass.i18n.de }}
              </b-dropdown-item>
            </b-dropdown>

          </div>

          <div class="col text-dark" v-html="i18n.newContentText(nextId())">
          </div>
        </div>

        <div class="row" v-if="course.content && course.content.length > 0">
          <div class="col">
            <b-button block variant="primary" append :to="{path: 'editNav'}">
              <i class="fas fa-project-diagram"></i> {{ i18n.editCourseNav }}
            </b-button>
          </div>

          <div class="col text-dark">
            <span v-if="courseNavIncomplete()"
                  class="bg-warning mr-1 rounded"
                  style="padding: 2px 5px">
              <i class="fas fa-exclamation-triangle"></i> {{ i18n.incomplete }}
            </span>
            <span v-html="i18n.editCourseNavText(course.content.length)"></span>
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <b-button size="sm"
                      variant="warning"
                      class="float-right"
                      @click="$bvModal.show('author-renameCourse-confirm')">
              <i class="fas fa-exclamation-circle"></i> {{ i18n.renameCourseButton }}
            </b-button>
          </div>

          <div class="col text-dark">
            {{ i18n.renameCourseAction }}
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <b-button size="sm"
                      variant="warning"
                      class="float-right"
                      @click="$bvModal.show('author-copyCourse-confirm')">
              <i class="fas fa-exclamation-circle"></i> {{ i18n.copyCourseButton }}
            </b-button>
          </div>

          <div class="col text-dark">
            {{ i18n.copyCourseAction }}
          </div>
        </div>

        <div class="row mt-5" v-if="content()">
          <div class="col">
            <b-button size="sm"
                      variant="danger"
                      class="float-right"
                      @click="$bvModal.show('author-delContent-confirm')">
              <i class="fas fa-exclamation-circle"></i> {{ i18n.removeContentButton }}
            </b-button>
          </div>

          <div class="col text-dark">
            {{ i18n.removeContentAction }}
          </div>
        </div>

        <div class="row mt-3">
          <div class="col">
            <b-button size="sm"
                      variant="danger"
                      class="float-right"
                      @click="$bvModal.show('author-delCourse-confirm')">
              <i class="fas fa-exclamation-circle"></i> {{ i18n.removeCourseButton }}
            </b-button>
          </div>

          <div class="col text-dark" v-html="i18n.removeCourseAction">
          </div>
        </div>


      </div>
    </div>

  </div>
</template>

<script>
import { mapState, mapGetters } from 'vuex'

import {
  BDropdown,
  BDropdownItem,
  BDropdownHeader,
  BDropdownDivider,
  BToast, BvToast,
  BModal, BvModal
} from 'bootstrap-vue'

import http from 'axios';
import utils from '../misc/utils.js';

import * as i18n from '@/i18n/courses';
import courseService from '@/misc/course-service';

export default {
  name: 'course-detail-view',
  props: {
    id: String,
    step: String
  },
  data() {
    return {
      course: {},
      userEnrolled: false,
      renameCourseNewName: '',
      copyCourseNewName: '',
      changetype: null
    }
  },
  beforeRouteUpdate(to, from, next) {
    document.getElementById('main-content-anchor').scrollIntoView()
    next()
  },
  created() {
    window.scrollTo(0, 0)
    this.loadCourse()
  },
  computed: {
    ...mapState(['auth', 'note', 'profile']),
    ...mapGetters(['isAuthor']),

    i18n() {
      return i18n[this.profile.lang];
    },

    /* returns empty function on every [] invocation */
    onFinishDummy() {
      return new Proxy({}, {
        get(target, name) {
          return () => {}
        }
      })
    },

    plugins() {
      const la = this.$laya.la
      const lb = this.$laya.lb
      let lalb = [{ value: null, text: 'Neuen Typ wählen', disabled: true }]
      for (const id in lb)
        lalb.push({ value: id, text: lb[id].i18n.de })
      for (const id in la)
        lalb.push({ value: id, text: la[id].i18n.de })
      return lalb
    }
  },
  methods: {
    ...utils,

    compView(name) {
      const la = this.$laya.la[name]
      return la ? la.components.view : this.$laya.lb[name].components.view
    },

    content() {
      return this.course && this.course.content && this.course.content[this.step - 1]
    },

    loadCourse() {
      this.$store.commit('setBusy', true);
      /* fetch course */
      http.get(`courses/${this.id}`)
          .then(({ data }) => {
            this.course = data;
            document.title = `Laya - ${this.course.name}`
          })
          .catch(err => {
            console.error(err);
            this.$router.push(`/courses/${this.profile.lang}`);
          })
          .then(() => this.$store.commit('setBusy', false));
    },

    updateStep(changedStep) {
      if (this.course.content && this.course.content.length > 0) {
        this.course.content[this.step - 1] = {
          ...this.course.content[this.step - 1], ...changedStep
        }
      } else {
        this.course.content = [{
          ...changedStep
        }];
      }
      this.storeCourse()
      this.$forceUpdate()
    },

    updateContent(changedContent) {
      this.course.content = [...changedContent]
      this.storeCourse()
      this.$forceUpdate()
    },

    delContent() {
      this.course.content.splice(this.step - 1, 1)
      this.storeCourse()
    },

    delCourse() {
      http.delete(`courses/${this.course.id}`)
          .then(() => {
            this.$router.push(`/courses/${this.profile.lang}`)
          }).catch(err => console.error('Failed to delete course:', err))
    },

    copyCourse() {
      if (!this.copyCourseNewName) return

      let copied_course = { ...this.course }
      delete copied_course.id;
      copied_course.name = this.copyCourseNewName
      http.post(`courses`, copied_course)
          .then(({ data }) => {
            this.$router.push({ name: 'course-detail-view', params: { id: data.id, step: '1' } })
          }).catch(err => {
            console.error('Failed course copy:', err)
          }).finally(() => {
            this.$bvToast.show('author-toast')
            this.loadCourse()
            this.$forceUpdate()
          })
    },

    renameCourse() {
      if (!this.renameCourseNewName) return

      this.course.name = this.renameCourseNewName;
      this.storeCourse()
      this.$forceUpdate()
    },

    changeContentType() {
      if (!this.changetype) return

      this.updateStep({ name: this.changetype, input: null })
    },

    storeCourse() {
      http.patch(`courses/${this.course.id}`, { name: this.course.name, content: this.course.content })
          .catch(err => console.error('Failed storing course content:', err))
          .finally(() => {
            this.$bvToast.show('author-toast')
          })
    },

    courseNavIncomplete() {
      return this.course.content.reduce((all, c) => (!c.nextStep || all), false)
    },

    nextStep(steps) { // string e.g. "1,2"
      if (!steps) return []

      const { id, $router } = this
      return steps.split(',').map(step => {
        return () => {
          $router.push({ name: 'course-detail-view', params: { id, step } })
        }
      })
    },

    nextId() {
      return this.course.content ? this.course.content.length + 1 : 1;
    }

    /*
    subscribe() {
      const ctx = this;
      const ctx = this;
      http
        .put(`accounts/${ctx.auth.userId}/mycourses/rel/${ctx.course.id}`)
        .then(({ data }) => {
          ctx.$store.commit("addMyCourse");
          ctx.userEnrolled = true;
        })
        .catch(err => console.error(err));
    },

    unsubscribe() {
      const ctx = this;
      ctx.$store.commit("setBusy", true);
      http
        .delete(`accounts/${ctx.auth.userId}/mycourses/rel/${ctx.course.id}`)
        .then(({ data }) => {
          ctx.userEnrolled = false;
        })
        .catch(err => console.error(err))
        .then(() => {
          ctx.$store.commit("setBusy", false);
        });
    },

    learn() {
      const ctx = this;
      http.get(`courses/${ctx.course.id}/startInteraction`)
        .then(({ data }) => {
          console.log("data", data);
          let li = ctx.$laya.lookupType(data.assessmentType);
          switch (li.type) {
            case "assessment":
              ctx.$router.push({
                name: "assessment-view",
                // FIXME data.id might be inconsistent with specific with Assessment's id. Ask Sebastian for details
                params: { type: li.id, assId: data.id }
              });
              break;
            case "block":
              // TODO add logic for learning blocks.
          }
        });
    }
    */
  },
  components: {
    BDropdown,
    BDropdownItem,
    BDropdownHeader,
    BDropdownDivider,
    BToast, BvToast,
    BModal, BvModal
  }
};
</script>

<style scoped>
*:focus {
  outline: 2px dashed deepskyblue;
}

.author-tools-active {
  border-bottom: 2px solid black;
  color: black !important;
}

.author-toast {
  position: fixed;
  top: 10px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 11002;
}

.subscribe-btn {
  border: 2px solid black;
}
</style>
